import SetStatusCommentAllContainer from "./SetStatusCommentAllContainer";
export default SetStatusCommentAllContainer;
